export const BeneficiaryLink = [
    { value: 'Enfant', label: 'Enfant' },
    { value: 'Conjoint', label: 'Conjoint' },
    { value: 'Famille', label: 'Famille' },
    { value: 'Mariage', label: 'Mariage' },
]
